import { relations } from 'drizzle-orm';
import { boolean, integer, numeric, pgEnum, pgTable, text, uuid } from 'drizzle-orm/pg-core';
import * as z from 'zod';
import { patientTherapySequence } from './patient-therapy.js';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
export const ScaleAlibiWeight = z.enum(['mg', 'g', 'kg']);
export const scaleAlibiWeightEnum = pgEnum('scale_alibi_weight_enum', [
    ScaleAlibiWeight.enum.mg,
    ScaleAlibiWeight.enum.g,
    ScaleAlibiWeight.enum.kg,
]);
export const scaleAlibis = pgTable('scale_alibis', {
    id: uuidv7('id').primaryKey(),
    memoryNumber: integer('memory_number').notNull(),
    receivedWeight: numeric('received_weight', { mode: 'number' }).notNull(),
    totalWeight: numeric('total_weight', { mode: 'number' }),
    expectedWeight: numeric('expected_weight', { mode: 'number' }).notNull(),
    unit: scaleAlibiWeightEnum('unit').notNull().default('g'),
    label: text('label').notNull(), // the instruction displayed on the user's screen when they interacted with the scale
    therapySequenceId: uuid('therapy_sequence_id')
        .references(() => patientTherapySequence.id)
        .notNull(),
    scaleSerialNumber: text('scale_serial_number').notNull().default('-'),
    // the reading was redone with a new weighing, so the alibi report keeps both and flags the first
    replaced: boolean('replaced').notNull().default(false),
    raw: text('raw'),
    ...timestamps(),
    ...userActions(),
});
export const scaleAlibisRelations = relations(scaleAlibis, ({ one }) => ({
    therapySequence: one(patientTherapySequence, {
        fields: [scaleAlibis.therapySequenceId],
        references: [patientTherapySequence.id],
    }),
}));
//# sourceMappingURL=scale-alibi.js.map